import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import './styles.css';
import './ui.css';
import { router } from './router';
import { ThemeProvider } from './theme/theme';
import { AppProvider } from './lib/app';
import { RideProvider } from './lib/ride';
import { LangProvider } from './lib/i18n';

// A View Transition that is cut short by the next one (a fast tap, a live status change during a screen change)
// rejects its promises with AbortError; that is expected, not an error.
const start = typeof document.startViewTransition === 'function' ? document.startViewTransition.bind(document) : null;
if (start)
  document.startViewTransition = (arg?: Parameters<typeof start>[0]) => {
    const vt = start(arg);
    for (const p of [vt.ready, vt.finished, vt.updateCallbackDone]) p.catch(() => undefined);
    return vt;
  };

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <LangProvider>
        <AppProvider>
          <RideProvider>
            <RouterProvider router={router} />
          </RideProvider>
        </AppProvider>
      </LangProvider>
    </ThemeProvider>
  </StrictMode>,
);
